export default __webpack_public_path__ + "static/media/logoSidebar.39caacb9.svg";